import { ViewSubSection } from "shared/components";
import { Dialpad } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";
import { PhoneNumbers, EmailAddresses } from "./components";

export const AdditionalContactInfo = () => {
  const { t } = useTranslation("people", {
    keyPrefix: "PERSON_CONTACT_INFO_MODAL.ADDITIONAL_CONTACT_INFO",
  });

  return (
    <Flex direction="column" gap="300">
      <ViewSubSection
        Icon={Dialpad}
        title={t("TITLE")}
        description={t("DESCRIPTION")}
      />

      {/* Phone Numbers Section */}
      <PhoneNumbers />

      {/* Email Addresses Section */}
      <EmailAddresses />
    </Flex>
  );
};
